import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { h as handleDismiss } from './index2.js';
import { d as defineCustomElement$6 } from './close-button.js';
import { d as defineCustomElement$5 } from './icon.js';
import { d as defineCustomElement$4 } from './tag.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const infoboxCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:var(--jw-theme-surface-level1-default-bg-color);border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-sizing:border-box;color:var(--jw-theme-surface-text-default-color);display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:1rem .75rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host ::slotted(p){color:var(--jw-theme-surface-text-default-color)!important;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem}header{align-items:center;display:inline-flex;flex:1;justify-content:space-between}";
const WuiInfoboxStyle0 = infoboxCss;

const WuiInfobox$1 = /*@__PURE__*/ proxyCustomElement(class WuiInfobox extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dismiss = createEvent(this, "dismiss", 3);
        this.handleDismiss = () => handleDismiss(this);
        this.dismissible = true;
        this.label = 'How to';
        this.icon = undefined;
        this.tooltip = undefined;
    }
    render() {
        return (h(Host, { key: 'd729abd442bde66c9f69563d0462dcb6e654a74c' }, (this.label || this.dismissible) && (h("header", { key: 'bccd8682b324274f9fb1c4c8a3de587998ea9cdb' }, this.label && h("wui-tag", { key: '08fd0f05f2b9b6ca7ca8aa11347b1ac75ce91b3d', label: this.label, icon: this.icon || 'bulb' }), this.dismissible && h("wui-close-button", { key: '0bcad4d994331b523707ae4e86314e44ac8aa504', onClick: this.handleDismiss, tooltip: this.tooltip }))), h("slot", { key: 'b5f2de7f5ae3c7c411be89d8ed41b2498dbc6d6d' })));
    }
    get el() { return this; }
    static get style() { return WuiInfoboxStyle0; }
}, [1, "wui-infobox", {
        "dismissible": [4],
        "label": [1],
        "icon": [1],
        "tooltip": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-infobox", "wui-close-button", "wui-icon", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-infobox":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiInfobox$1);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiInfobox = WuiInfobox$1;
const defineCustomElement = defineCustomElement$1;

export { WuiInfobox, defineCustomElement };

//# sourceMappingURL=wui-infobox.js.map